import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import Grid from "../../components/Grid";
import Button from "../input/Button";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import { getBulkDropdownData, getOtherRefSearchDropdown, getTextByValueAndKey, getFieldValuesByTableAndId, getOtherRefTextByValueAndKey } from "../../api/keyvalue";
import { FORMS, MODULES } from "../../const";
import LoadingSpinner from "../LoadingSpinner";
import { getTags } from "../../api/tagApi";
import { getIssuesByVehicle } from "../../api/workOrderApi";
import { IssuePriorityCellStyle, IssueStatusCellStyle, ResizableScrollingTextRenderer } from "../renderer/StyleRenderer";
import { deleteIssue } from "../../api/issueApi";
import Modal from "../../components/Modal";
import { toast } from "react-toastify";
import CheckBox from "../input/CheckBox";
import DateTimePickerInput from "../input/DateTimePickerInput";
import { getBehalfOf, getUsernameById } from "../../api/systemUserApi";
import MultiInput from "../input/MultiInput";
import useUserCompany from "../../hooks/useUserCompany";
import DocumentUpload from "../DocumentUpload";
import { addAndUpload, updateAndUpload, deleteDocumentList, getDocumentByOpeAndRef } from "../../api/documentUpload";
import { workOrderVendorValidation } from "../validations/WorkOrderCreation";
import InfoList from "../InfoList";
import { formatFromJsonDate } from "../../dateConfig";
import { User } from "react-feather";
import {useSelector} from "react-redux";
const FORM = FORMS.FLEET_WORK_ORDER.INFO.form
const STRINGL_REGEX = /^[a-zA-Z0-9@._\-\s]+$/;
const WorkOrderForm = forwardRef(({
    editMode,
    handleDrawerClose,
    currentValues,
    errors,
    isLoading,

}, ref) => {
    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
        userCompany ? userCompany.comId : null
    );

    useEffect(() => {
        setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [currentErrors, setCurrentErrors] = useState(errors);
    useEffect(() => {
        setCurrentErrors(errors || {});
    }, [errors]);
    //utils
    const today = new Date().toISOString().split("T")[0];
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [workOrder, setWorkOrder] = useState(
        editMode
            ? { ...(currentValues?.workOrder || {}) }
            : {
                fwoCode: "",
                fwoVehicle: "",
                fwoVehicleNumber: "",
                fwoType: 1,
                fwoLabel: [],
                fwoReason: "",
                fwoScheduledStatrtTime: null,
                fwoActualStatrtDate: null,
                fwoStartDateReminder: 0,
                fwoNotifyReminder: 0,
                fwoNotifyUser: null,
                fwoAlertType: null,
                fwoSameOdometer: 0,
                fwoStartOdometer: null,
                fwoCompletionOdometer: null,
                fwoExpectedCompletionDate: null,
                fwoActualCompletionDate: null,
                fwoStatus: 1,
                fwoActive: 1,
                minToDate: today,
                fwoRepairPriority: 1,
                fwoCompany: company,
            }
    );
    const [issueList, setIssueList] = useState(
        editMode ? (currentValues?.issues || []) : []
    );
    const manualStatusChangeRef = useRef(false);
    useEffect(() => {
        if (manualStatusChangeRef.current) {
            manualStatusChangeRef.current = false;
            return;
        }
        setWorkOrder(prev => ({
            ...prev,
            fwoStatus: prev.fwoActualStatrtDate && (prev.fwoActualCompletionDate === null || prev.fwoActualCompletionDate === "")
                ? 6
                : prev.fwoActualCompletionDate
                    ? 3
                    : 1
        }));
    }, [workOrder.fwoActualStatrtDate, workOrder.fwoActualCompletionDate]);
    const [fwiIssue, setFwiIssue] = useState({
        minToDate: today,
    });
    const [workOrderIssue, setWorkOrderIssue] = useState({
        fwiCode: "",
        fwiInvNo: [],
        fwiPoNo: [],
    });

    const [vendorErrors, setVendorErrors] = useState({});
    const [deletedIssues, setDeletedIssues] = useState([]);
    const [issueLoading, setIssueLoading] = useState(false);
    const [fieldReset, setFieldReset] = useState(false);
    const modalRef = useRef(null);
    const [expandedIssue, setExpandedIssue] = useState(null);
    const [selectedVendorInput, setSelectedVendorInput] = useState(null);
    const [availableIssues, setAvailableIssues] = useState([]);
    const [statusOpt, setStatusOpt] = useState([]);
    const [priorityOpt, setPriorityOpt] = useState([]);
    const [tagOptions, setTagOptions] = useState([]);
    const [alertTypeOpt, setAlertTypeOpt] = useState([]);
    const [repairPriorityOpt, setRepairPriorityOpt] = useState([]);
    const docModalRef = useRef(null);
    const docUploadRef = useRef(null);
    const [activeDocVendorKey, setActiveDocVendorKey] = useState(null);
    const [activeDocFwivId, setActiveDocFwivId] = useState(null);
    const [docTypeOptions, setDocTypeOptions] = useState([]);
    const [docStatusOptions, setDocStatusOptions] = useState([]);
    const [activeOptions, setActiveOptions] = useState([]);
    const [existingDocs, setExistingDocs] = useState({});
    const [isDocSaveLoading, setIsDocSaveLoading] = useState(false);
    const [fileNameOptions, setFileNameOptions] = useState([]);
    const [pendingDocsByVendorKey, setPendingDocsByVendorKey] = useState({});
    const auth = useSelector((state) => state.user.permissions[MODULES?.Fleet]);
    const closePermission = auth?.FLEET_WORK_ORDER?.FORM?.CLOSED;

    useEffect(() => {
        if (editMode) {
            (async () => {
                // First fetch missing vehicle name if needed
                let woInfo = { ...currentValues?.workOrder };
                if (!woInfo.fwoVehicleNumber && woInfo?.fwoVehicle) {
                    try {
                        const fetchedName = await getOtherRefTextByValueAndKey("vehicle", "", woInfo.fwoVehicle);
                        if (fetchedName) {
                            woInfo.fwoVehicleNumber = fetchedName;
                        }
                    } catch (e) {
                        console.error("Failed to fetch vehicle name", e);
                    }
                }

                if (woInfo?.fwoNotifyUser && !woInfo.fwoNotifyUserName) {
                    try {
                        const userName = await getUsernameById(woInfo.fwoNotifyUser);
                        if (userName) {
                            woInfo.fwoNotifyUserName = userName;
                        }
                    } catch (e) {
                        console.error("Failed to fetch notify user name", e);
                    }
                }

                setWorkOrder({ ...woInfo, fwoVehicleNumber: woInfo.fwoVehicleNumber || "" });

                if (!Array.isArray(currentValues?.issues)) return;

                const enrichedIssues = await Promise.all(
                    currentValues?.issues.map(async (issue) => {
                        const vendorRecords = issue.fwiVendors || [];
                        const ids = vendorRecords.map(v => v.fwivVendor).filter(Boolean);

                        if (ids.length === 0) return { ...issue, fwiVendor: {} };

                        try {
                            let idList = [];
                            for (const id of ids) {
                                const rows = await getFieldValuesByTableAndId({
                                    tableName: "masterdata.tms_m_stakeholder",
                                    primaryKey: "stk_id",
                                    fieldNames: "stk_name",
                                    ids: id,
                                });
                                idList.push(rows);
                            }


                            const nameMap = (idList || []).reduce((acc, row) => {
                                acc[row.pkId] = row.field1;
                                return acc;
                            }, {});

                            const vendorMap = vendorRecords.reduce((acc, record) => {
                                const vendorId = record.fwivVendor;
                                acc[vendorId] = {
                                    name: nameMap[vendorId] || `Vendor ${vendorId}`,
                                    fwivInvNo: record.fwivInvNo || [],
                                    fwivPoNo: record.fwivPoNo || [],
                                    fwivId: record.fwivId
                                };
                                return acc;
                            }, {});
                            let priorityText = "";
                            const priorityId = issue?.issue?.fliPriority ?? issue?.fliPriority;
                            if (priorityId) {
                                priorityText = await getTextByValueAndKey("priority", priorityId);
                            }

                            return { ...issue, fwiVendor: vendorMap, priority: priorityText };
                        } catch {
                            return { ...issue, fwiVendor: {} };
                        }
                    })
                );
                setIssueList(enrichedIssues);

            })();
        }
    }, [currentValues, editMode]);

    useEffect(() => {
        setCurrentErrors(errors);
    }, [errors]);

    useEffect(() => {
        (async () => {
            const tags = await getTags();
            const formatted = tags.map(tag => ({
                key: tag.ftaId,
                value: tag.ftaId,
                text: tag.ftaLabel
            }));
            setTagOptions(formatted);
        })();
    }, []);

    useEffect(() => {
        if (workOrder?.fwoVehicle) {
            setIssueLoading(true);
            getIssuesByVehicle(workOrder?.fwoVehicleNumber)
                .then(async (data) => {
                    const filtered = (data || []).filter(
                        (issue) => (issue.fliStatus === 1 || issue.fliStatus === 2) && (issue.fliCheckOverDue === null || issue.fliCheckOverDue === false)  && issue.fliActive === 1
                    );
                    const mapped = await Promise.all(
                        filtered.map(async (issue) => {
                            const priorityText = await getTextByValueAndKey(
                                "priority",
                                issue.fliPriority
                            );
                            return {
                                ...issue,
                                priority: priorityText || "",
                            };
                        })
                    );
                    setAvailableIssues(mapped);

                    if (!editMode) {
                        setIssueList(mapped);
                    }
                })
                .catch(() => {
                    setAvailableIssues([]);
                    if (!editMode) setIssueList([]);
                })
                .finally(() => setIssueLoading(false));
        } else {
            setAvailableIssues([]);
            if (!editMode) setIssueList([]);
            setExpandedIssue(null);
        }
    }, [workOrder?.fwoVehicle, workOrder?.fwoVehicleNumber, editMode]);

    useEffect(() => {
        (async () => {
            const {
                priority,
                service_status,
                alert_type,
                repair_priority,
                active,
                status,
                doc_type: docType,
                "file_name#9": fileNameOpt = [],
            } = await getBulkDropdownData([
                { key: "priority" },
                // { key: "service_status" },
                {
                    key: "service_status",
                    authenticated: true,
                    authorities: [
                        "FLEET_WORK_ORDER_FORM_CLOSED",
                        "FLEET_WORK_ORDER_FORM_OPEN",
                        "FLEET_WORK_ORDER_FORM_INPROGRESS",
                        "FLEET_WORK_ORDER_FORM_OVERDUE",
                        "FLEET_WORK_ORDER_FORM_RESOLVED",
                        "FLEET_WORK_ORDER_FORM_ONHOLD",
                    ],
                },
                { key: "alert_type" },
                { key: "repair_priority" },
                { key: "active" },
                { key: "status" },
                { key: "doc_type" },
                { key: "file_name", group: "9" },

            ]);

            console.log("service_status", service_status);
            setStatusOpt(service_status);
            setPriorityOpt(priority);
            setAlertTypeOpt(alert_type);
            setRepairPriorityOpt(repair_priority);
            setDocTypeOptions(docType || []);
            setDocStatusOptions(status || []);
            setActiveOptions(active || []);
            setFileNameOptions(fileNameOpt);
        })();
    }, []);

    const handleDeleteIssue = (issueId) => {
        try {
            const issueToDelete = issueList.find(i => (i?.issue?.fliId ?? i.fliId) === issueId);
            if (issueToDelete && issueToDelete.fwiId) {
                setDeletedIssues(prev => [...prev, issueToDelete]);
            }

            setIssueList((prev) => prev.filter(i => (i?.issue?.fliId ?? i.fliId) !== issueId));
            toast.success("Issue deleted successfully", { containerId: "Main" });
        } catch (error) {
            toast.error("Failed to delete issue", { containerId: "Main" });
        }
    };

    useImperativeHandle(ref, () => ({
        getData: () => {
            const mapIssuePayload = (issue, isActive) => ({
                fwiId: issue.fwiId ?? null,
                fwiIssue: issue.fwiIssue ?? issue.fliId,
                fwiVendors: Object.entries(issue.fwiVendor || {}).map(([id, data]) => {
                    return {
                        fwivVendor: Number(id),
                        fwivInvNo: data?.fwivInvNo || data?.fwiInvNo || [],
                        fwivPoNo: data?.fwivPoNo || data?.fwiPoNo || [],
                        fwivId: data?.fwivId,
                    };
                }),
                fwiStartTime: issue.fwiStartTime ?? null,
                fwiEndTime: issue.fwiEndTime ?? null,
                fwiStatus: issue.fwiStatus ?? 6,
                fwiActive: isActive ? (issue.fwiActive ?? 1) : 2, // 2 if deleted
            });

            return {
                ...workOrder,
                issues: [
                    ...issueList.map(issue => mapIssuePayload(issue, true)),
                    ...deletedIssues.map(issue => mapIssuePayload(issue, false))
                ]
            };
        },
        getPendingDocuments: () => pendingDocsByVendorKey,
    }));
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div style={{ padding: "20px" }}>
                    <form className="ui form"
                        style={{ overflowY: "auto", height: "80vh" }}>
                        <div style={{ marginBottom: "20px" }}>
                            <div className={"ui segment"}>
                                <h4 className="ui dividing header">Add Work Order</h4>
                                <div className="two fields">
                                    <SearchDropdown
                                        label="Vehicle"
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        editMode={editMode}
                                        required={true}
                                        clearable={true}

                                        api={getOtherRefSearchDropdown}
                                        apiDependency={{ type: "vehicle" }}
                                        returnFullObject={true}
                                        onResultSelect={(data) =>
                                            setWorkOrder((prevState) => ({
                                                ...prevState,
                                                fwoVehicle: data.value,
                                                fwoVehicleNumber: data.title
                                            }))
                                        }
                                        onClear={() => {
                                            setWorkOrder((prevState) => ({
                                                ...prevState,
                                                fwoVehicle: null,
                                                fwoVehicleNumber: "",
                                            }));
                                        }}
                                        fieldInfo={{
                                            tableName: "masterdata.tms_m_vehicle_details",
                                            primaryKey: "veh_id",
                                            fieldName: "veh_vehicleno",
                                            id: workOrder.fwoVehicle,
                                        }}
                                        reset={searchFieldReset}
                                        setReset={setSearchFieldReset}
                                        error={currentErrors?.fwoVehicle}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoVehicle: _, ...rest } = prevState;
                                                return rest;
                                            })
                                        }
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />

                                    <Dropdown
                                        label="Labels"
                                        placeholder="Select Tags"
                                        fluid
                                        multiple
                                        search
                                        selection
                                        options={tagOptions}
                                        value={workOrder.fwoLabel || []}
                                        onChange={(e, data) => {
                                            setWorkOrder(prev => ({
                                                ...prev,
                                                fwoLabel: data.value
                                            }));
                                        }}
                                        style={{
                                            minHeight: "38px",
                                            height: "auto",
                                            display: "flex",
                                            alignItems: "flex-start",
                                            flexWrap: "wrap"
                                        }}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />
                                </div>
                                <div className="one field">
                                    <label>Reason for Repair</label>
                                    <textarea
                                        rows="3"
                                        placeholder="Enter Reason for Repair"
                                        style={{ resize: "vertical" }}
                                        value={workOrder.fwoReason || ""}
                                        onChange={(e) => {
                                            setWorkOrder(prevState => ({
                                                ...prevState,
                                                fwoReason: e.target.value
                                            }))
                                        }}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />
                                </div>
                            </div>

                            {/* ISSUE COMPONENT PLACEHOLDER */}
                            <div className="ui segment" style={{ padding: "20px" }}>
                                <div className="issue-section-header header">
                                    <h4 className="ui dividing" style={{ textTransform: "uppercase" }}>Issues</h4>
                                    <div className="issue-section-header-left">
                                        <span><strong>{issueList.length} ISSUES</strong></span>
                                        <Button template="addOrSave"
                                            editMode={editMode}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                modalRef.current?.showModal();
                                            }}
                                            isLoading={isLoading}
                                            disabled={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        />
                                    </div>
                                </div>

                                {!issueLoading && issueList.map((issue) => {
                                    const issueKey = issue?.issue?.fliId ?? issue.fliId;
                                    const issueCode = issue?.issue?.fliCode ?? issue.fliCode;
                                    const issueTopic = issue?.issue?.fliTopic ?? issue.fliTopic ?? issueKey;
                                    const issuePriority = issue?.issue?.fliPriority ?? issue.fliPriority;
                                    const issueStatus = issue?.issue?.fliStatus ?? issue.fliStatus;
                                    const issueStartTime = issue?.fwiStartTime;
                                    const issueEndTime = issue?.fwiEndTime;
                                    const priorityName = issue.priority || "";
                                    const issueStatusName =
                                        statusOpt.find((opt) => Number(opt.value) === Number(issueStatus))?.text ||
                                        issueStatus ||
                                        "";
                                    return (
                                        <div key={issueKey} className="ui segment"
                                            style={{ padding: 0, marginBottom: "15px" }}>
                                            <div
                                                className={`issue-row-header${expandedIssue === issueKey ? " issue-row-header--active" : ""}`}
                                                onClick={() => {
                                                    setExpandedIssue(expandedIssue === issueKey ? null : issueKey);
                                                    setSelectedVendorInput(null);
                                                    setFieldReset(true);
                                                }}
                                            >
                                                <div className="issue-row-left">
                                                    <span className="issue-no-label">{issueCode}</span>
                                                    <span
                                                        className={expandedIssue === issueKey ? "issue-title--muted" : "issue-title"}>
                                                        {issueTopic}
                                                    </span>
                                                </div>
                                                <div className="issue-row-right">
                                                    <IssuePriorityCellStyle value={priorityName} />
                                                    <IssueStatusCellStyle value={issueStatusName} />
                                                    <i className={`angle ${expandedIssue === issueKey ? 'up' : 'down'} icon`}></i>
                                                    <Button
                                                        type="button"
                                                        label={"—"}
                                                        className={"ui red button"}
                                                        disabled={!!issueStartTime}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDeleteIssue(issueKey);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {expandedIssue === issueKey && (
                                                <div className="ui form" style={{ padding: "20px" }}>
                                                    <div className="two fields">
                                                        <Input label="Issue No." value={issueCode || ""}
                                                            disabled={true} />
                                                        <div className="field">
                                                            <label>Description</label>
                                                            <textarea rows="5" value={issue.fliDescription || ""}
                                                                placeholder="Describe the issue..."
                                                                style={{ resize: "vertical" }} disabled={true} />
                                                        </div>
                                                    </div>
                                                    <div className="two fields">
                                                        <Input label="Topic" value={issueTopic || ""} disabled={true} />
                                                        <Dropdown
                                                            label="Priority"
                                                            options={priorityOpt}
                                                            value={issuePriority}
                                                            disabled={true}
                                                        />

                                                    </div>
                                                    <div className="two fields">
                                                        <Dropdown
                                                            label="Status"
                                                            options={statusOpt}
                                                            value={issueStatus}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="two fields">
                                                        <DateTimePickerInput
                                                            required={workOrder.fwoStatus === 4}
                                                            label="Actual Start Date & Time"
                                                            placeholder="Start Date & Time"
                                                            name="startDate"
                                                            value={issueStartTime || ""}
                                                            onAccept={(val) => {
                                                                setIssueList((prev) =>
                                                                    prev.map((itm) =>
                                                                        (itm?.issue?.fliId ?? itm.fliId) === issueKey
                                                                            ? { ...itm, fwiStartTime: val }
                                                                            : itm
                                                                    )
                                                                );
                                                            }}
                                                            minDateTime={new Date(workOrder?.fwoActualStatrtDate) <= yesterday ? yesterday: new Date(workOrder?.fwoActualStatrtDate) }
                                                            maxDateTime={new Date()}
                                                            editMode={editMode}
                                                            module={MODULES.Fleet}
                                                            form={FORM}
                                                            resetError={() =>
                                                                setCurrentErrors((prevState) => {
                                                                    const { [`issueStartTime_${issueKey}`]: _, ...rest } = prevState;
                                                                    return rest;
                                                                })
                                                            }
                                                            error={currentErrors?.[`issueStartTime_${issueKey}`]}
                                                            readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                        />
                                                        <DateTimePickerInput
                                                            required={workOrder.fwoStatus === 4}
                                                            disabled={!issueStartTime}
                                                            label="Actual End Date & Time"
                                                            placeholder="End Date & Time"
                                                            name="endDate"
                                                            value={issueEndTime || ""}
                                                            onAccept={(val) => {
                                                                const resolvedOpt = statusOpt.find(opt => String(opt.text).toLowerCase() === "resolved");
                                                                const resolvedValue = resolvedOpt ? resolvedOpt.value : 3;

                                                                setIssueList((prev) =>
                                                                    prev.map((itm) => {
                                                                        if ((itm?.issue?.fliId ?? itm.fliId) === issueKey) {
                                                                            const updatedItem = { ...itm, fwiEndTime: val };
                                                                            if (val) {
                                                                                updatedItem.fwiStatus = resolvedValue;
                                                                                updatedItem.fliStatus = resolvedValue;
                                                                                if (updatedItem.issue) {
                                                                                    updatedItem.issue = { ...updatedItem.issue, fliStatus: resolvedValue };
                                                                                }
                                                                            }
                                                                            return updatedItem;
                                                                        }
                                                                        return itm;
                                                                    })
                                                                );
                                                            }}
                                                            maxDateTime={new Date()}
                                                            minDateTime={issueStartTime}
                                                            editMode={editMode}
                                                            validators={(() => {
                                                                const endTimes = issueList.map(i => i.fwiStartTime).filter(Boolean);
                                                                if (endTimes.length === 0) return [];
                                                                const maxEnd = endTimes.reduce((max, t) => (new Date(t) > new Date(max) ? t : max));
                                                                return [{
                                                                    func: (date) => {
                                                                        const actualMin = Math.floor(date.valueOf() / 60000);
                                                                        const scheduledMin = Math.floor(new Date(maxEnd).valueOf() / 60000);
                                                                        return actualMin >= scheduledMin;
                                                                    },
                                                                    message: "Actual End Date & Time must be on or after the latest issue Start Date & Time",
                                                                }];
                                                            })()}
                                                            module={MODULES.Fleet}
                                                            form={FORM}
                                                            resetError={() =>
                                                                setCurrentErrors((prevState) => {
                                                                    const { [`issueEndTime_${issueKey}`]: _, ...rest } = prevState;
                                                                    return rest;
                                                                })
                                                            }
                                                            error={currentErrors?.[`issueEndTime_${issueKey}`]}
                                                            readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                        />
                                                    </div>

                                                    <div className={"ui segment"}>
                                                        <h4 className="ui dividing header">Add Vendors</h4>
                                                        <div className="two fields">
                                                            <div className="field">
                                                                <MultiInput
                                                                    value={workOrderIssue.fwiInvNo}
                                                                    onChange={(val) => {
                                                                        setWorkOrderIssue(prevState => ({
                                                                            ...prevState,
                                                                            fwiInvNo: val
                                                                        }))
                                                                    }}
                                                                    label={"Invoice No."}
                                                                    placeholder={""}
                                                                    regex={STRINGL_REGEX}
                                                                    readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                                />
                                                            </div>
                                                            <div className="field">
                                                                <MultiInput
                                                                    value={workOrderIssue.fwiPoNo}
                                                                    onChange={(val) => {
                                                                        setWorkOrderIssue(prevState => ({
                                                                            ...prevState,
                                                                            fwiPoNo: val
                                                                        }))
                                                                    }}
                                                                    label={"PO No."}
                                                                    placeholder={"Enter PO No."}
                                                                    regex={STRINGL_REGEX}
                                                                    readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="two fields">
                                                            <SearchDropdown
                                                                label="Vendor"
                                                                editMode={editMode}
                                                                module={MODULES.Fleet}
                                                                form={FORM}
                                                                required={true}
                                                                clearable={true}
                                                                api={getOtherRefSearchDropdown}
                                                                apiDependency={{
                                                                    type: "stakeholder_type",
                                                                    value: "Vendor"
                                                                }}
                                                                returnFullObject={true}
                                                                onResultSelect={(data) => {
                                                                    setSelectedVendorInput(data);
                                                                    setVendorErrors(prev => ({ ...prev, selectedVendor: null }));
                                                                }}
                                                                onClear={() => {
                                                                    setSelectedVendorInput(null);
                                                                }}
                                                                reset={fieldReset}
                                                                setReset={setFieldReset}
                                                                error={vendorErrors?.selectedVendor}
                                                                resetError={() =>
                                                                    setCurrentErrors((prevState) => {
                                                                        const { selectedVendor: _, ...rest } = prevState;
                                                                        return rest;
                                                                    })
                                                                }
                                                                readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                            />

                                                        </div>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                justifyContent: "flex-end",
                                                                gap: "5px",
                                                            }}
                                                        >
                                                            <Button
                                                                template="addOrSave"
                                                                disabled={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    const validationErrors = workOrderVendorValidation({
                                                                        fwiInvNo: workOrderIssue.fwiInvNo,
                                                                        fwiPoNo: workOrderIssue.fwiPoNo,
                                                                        selectedVendor: selectedVendorInput?.value
                                                                    });

                                                                    if (Object.keys(validationErrors).length > 0) {
                                                                        setVendorErrors(validationErrors);
                                                                        return;
                                                                    }

                                                                    if (selectedVendorInput) {
                                                                        setVendorErrors({});
                                                                        setIssueList((prevState) =>
                                                                            prevState.map((itm) => {
                                                                                if ((itm?.issue?.fliId ?? itm.fliId) === issueKey) {
                                                                                    return {
                                                                                        ...itm,
                                                                                        fwiVendor: {
                                                                                            ...(itm.fwiVendor || {}),
                                                                                            [selectedVendorInput.value]: {
                                                                                                name: selectedVendorInput.title,
                                                                                                fwiInvNo: workOrderIssue.fwiInvNo || [],
                                                                                                fwiPoNo: workOrderIssue.fwiPoNo || []
                                                                                            },
                                                                                        },
                                                                                    };
                                                                                }
                                                                                return itm;
                                                                            })
                                                                        );
                                                                        setSelectedVendorInput(null);
                                                                        setFieldReset(true);
                                                                        setWorkOrderIssue(prev => ({
                                                                            ...prev,
                                                                            fwiInvNo: [],
                                                                            fwiPoNo: []
                                                                        }));
                                                                    }
                                                                }}
                                                            />
                                                        </div>


                                                    </div>
                                                    {Object.keys(issue.fwiVendor || {}).length > 0 && (
                                                        <div style={{ marginTop: "15px" }}>
                                                            <Grid
                                                                config={[
                                                                    {
                                                                        headerName: "Vendor Name",
                                                                        field: "name",
                                                                        flex: 1
                                                                    },
                                                                    {
                                                                        headerName: "Invoice No.",
                                                                        field: "fwiInvNo",
                                                                        flex: 1
                                                                    },
                                                                    {
                                                                        headerName: "PO No.",
                                                                        field: "fwiPoNo",
                                                                        flex: 1
                                                                    },
                                                                    {
                                                                        headerName: "Documents",
                                                                        field: "upload",

                                                                        cellRenderer: (params) => {
                                                                            const vendorKey = `${issueKey}_${params.data.id}`;
                                                                            const queuedCount = (pendingDocsByVendorKey[vendorKey] || []).length;
                                                                            const hasFwivId = !!params.data.fwivId;
                                                                            return (
                                                                                <span>
                                                                                    <Button
                                                                                        type="button"
                                                                                        template="drawerOpen"
                                                                                        label={queuedCount > 0 ? `Docs (${queuedCount})` : "Upload Doc"}
                                                                                        onClick={async (e) => {
                                                                                            e.preventDefault();
                                                                                            const vKey = `${issueKey}_${params.data.id}`;
                                                                                            setActiveDocVendorKey(vKey);
                                                                                            setActiveDocFwivId(params.data.fwivId ?? null);
                                                                                            if (editMode && hasFwivId) {
                                                                                                try {
                                                                                                    const docs = await getDocumentByOpeAndRef(31, params.data.fwivId);
                                                                                                    setExistingDocs(prev => ({
                                                                                                        ...prev,
                                                                                                        [vKey]: docs || []
                                                                                                    }));
                                                                                                } catch (err) {
                                                                                                    console.error("Failed to load vendor docs", err);
                                                                                                }
                                                                                            }
                                                                                            docModalRef.current?.showModal();
                                                                                        }}
                                                                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                                                    />
                                                                                </span>
                                                                            );
                                                                        },
                                                                    },
                                                                    {
                                                                        headerName: "Action",
                                                                        field: "action",

                                                                        cellRenderer: (props) => (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                justifyContent: "center"
                                                                            }}>
                                                                                <Button
                                                                                    type="button"
                                                                                    label="—"
                                                                                    className="ui red button"
                                                                                    disabled={editMode === true ? workOrder.fwoStatus === 4 || workOrder.fwoStatus === 3 : false}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setIssueList((prevList) =>
                                                                                            prevList.map((itm) => {
                                                                                                if ((itm?.issue?.fliId ?? itm.fliId) === issueKey) {
                                                                                                    const {
                                                                                                        [props.data.id]: _,
                                                                                                        ...rest
                                                                                                    } = itm.fwiVendor || {};
                                                                                                    return {
                                                                                                        ...itm,
                                                                                                        fwiVendor: rest
                                                                                                    };
                                                                                                }
                                                                                                return itm;
                                                                                            })
                                                                                        );
                                                                                    }}
                                                                                    readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                                                                />
                                                                            </div>
                                                                        ),
                                                                    },
                                                                ]}
                                                                content={Object.entries(issue.fwiVendor || {}).map(([id, data]) => {
                                                                    const vendorRecord = (issue.fwiVendors || []).find(
                                                                        v => String(v.fwivVendor) === String(id)
                                                                    );
                                                                    if (typeof data === "object" && data !== null) {
                                                                        return {
                                                                            id,
                                                                            fwivId: vendorRecord?.fwivId ?? null,
                                                                            name: data.name,
                                                                            fwiInvNo: data.fwiInvNo,
                                                                            fwiPoNo: data.fwiPoNo,
                                                                        };
                                                                    }
                                                                    return {
                                                                        id,
                                                                        fwivId: vendorRecord?.fwivId ?? null,
                                                                        name: data,
                                                                        fwiInvNo: [],
                                                                        fwiPoNo: [],
                                                                    };
                                                                })}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}

                            </div>
                            {/*Part 3*/}
                            <div className="segment" style={{ padding: "20px" }}>
                                <div className="two fields">
                                    <Dropdown
                                        label="Repair Priority"
                                        placeholder="Select Repair Priority"
                                        options={repairPriorityOpt}
                                        value={workOrder.fwoRepairPriority}
                                        onChange={(e, data) => {
                                            setWorkOrder((prevState) => ({
                                                ...prevState,
                                                fwoRepairPriority: data.value,
                                                fwoScheduledStatrtTime: null,
                                            }));
                                        }}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />
                                </div>
                                <div className="two fields">
                                    {workOrder.fwoRepairPriority === 1 && (
                                        <DateTimePickerInput
                                            required={true}
                                            label="Scheduled Start Date & Time"
                                            placeholder="Scheduled Start Date & Time"
                                            name="scheduleStartDate"
                                            value={workOrder.fwoScheduledStatrtTime || ""}
                                            onAccept={(val) => {
                                                setWorkOrder((prev) => ({
                                                    ...prev,
                                                    fwoScheduledStatrtTime: val,
                                                }));
                                            }}
                                            editMode={editMode}
                                            minDate={new Date()}
                                            resetError={() =>
                                                setCurrentErrors((prevState) => {
                                                    const { fwoScheduledStatrtTime: _, ...rest } = prevState;
                                                    return rest;
                                                })
                                            }
                                            error={currentErrors?.fwoScheduledStatrtTime}
                                            module={MODULES.Fleet}
                                            form={FORM}
                                            readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        />
                                    )}
                                    <DateTimePickerInput
                                        label="Actual Start Date"
                                        placeholder="Actual Start Date"
                                        name="fwoActualStatrtDate"
                                        value={workOrder.fwoActualStatrtDate || ""}
                                        onAccept={(val) => {
                                            console.log("actual start",val)
                                            console.log("today start",new Date());
                                            console.log("yesterday start",yesterday)
                                            setWorkOrder((prev) => ({
                                                ...prev,
                                                fwoActualStatrtDate: val,

                                            }));
                                        }}
                                        minDateTime={yesterday}
                                        maxDateTime={new Date()}
                                        validators={(() => {

                                            const startTimes = issueList.map(i => i.fwiStartTime).filter(Boolean);
                                            if (startTimes.length === 0) return [];

                                            const maxStart = startTimes.reduce((min, t) =>
                                                new Date(t) < new Date(min) ? t : min
                                            );

                                            return [{
                                                func: (date) => {
                                                    const actualMin = Math.floor(date.valueOf() / 60000);
                                                    const scheduledMin = Math.floor(new Date(maxStart).valueOf() / 60000);
                                                    return actualMin <= scheduledMin;
                                                },
                                                message: "Actual Date & Time must be before or equal to the earliest issue start time",
                                            }];
                                        })()}
                                        editMode={editMode}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                    />
                                </div>
                                <div className="field" style={{ marginBottom: "15px" }}>
                                    <CheckBox
                                        label="Send a Scheduled start date reminder"
                                        checked={workOrder.fwoStartDateReminder === true}
                                        onChange={() => {
                                            const isChecked = workOrder.fwoStartDateReminder === true;
                                            setWorkOrder(prev => ({
                                                ...prev,
                                                fwoStartDateReminder: !isChecked,
                                                ...(isChecked ? {
                                                    fwoNotifyUser: null,
                                                    fwoAlertType: null
                                                } : {})
                                            }));
                                        }}
                                        disabled={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />
                                </div>
                                {(workOrder.fwoStartDateReminder === true && (
                                    <div className="two fields">
                                        <SearchDropdown
                                            label="Notify User"
                                            name="fwoNotifyUser"
                                            required={true}
                                            clearable={true}
                                            returnFullObject={true}
                                            multiGrid={true}
                                            multiGridCurrentValue={workOrder.fwoNotifyUserName || workOrder.fwoNotifyUser || ""}
                                            onClear={() => setWorkOrder(prev => ({ ...prev, fwoNotifyUser: null, fwoNotifyUserName: null }))}
                                            onResultSelect={(data) => setWorkOrder(prev => ({ ...prev, fwoNotifyUser: data.value, fwoNotifyUserName: data.title }))}
                                            api={getBehalfOf}
                                            apiDependency={{
                                                customer: null,
                                                shipper: null,
                                            }}
                                            defaultValue={workOrder.fwoNotifyUserName || workOrder.fwoNotifyUser || ""}
                                            field="req_behalf_of"
                                            reset={fieldReset}
                                            setReset={setFieldReset}
                                            editMode={editMode}
                                            module={MODULES.Fleet}
                                            form={FORM}
                                            readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                            error={currentErrors?.fwoNotifyUser}
                                            resetError={() =>
                                                setCurrentErrors((prevState) => {
                                                    const { fwoNotifyUser: _, ...rest } = prevState;
                                                    return rest;
                                                })
                                            }
                                        />
                                        <Dropdown
                                            label="Alert Type"
                                            required={true}
                                            placeholder={"Select Alert Type"}
                                            options={alertTypeOpt}
                                            value={workOrder.fwoAlertType}
                                            onChange={(e, data) => setWorkOrder(prev => ({ ...prev, fwoAlertType: data.value }))}
                                            clearable
                                            module={MODULES.Fleet}
                                            form={FORM}
                                            readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                            error={currentErrors.fwoAlertType}
                                            resetError={() =>
                                                setCurrentErrors((prevState) => {
                                                    const { fwoAlertType: _, ...rest } = prevState;
                                                    return rest;
                                                })
                                            }
                                        />
                                    </div>
                                ))}

                                <div className="two fields">
                                    <Input
                                        type="text"
                                        label="Start Odometer"
                                        name="fwoStartOdometer"
                                        value={workOrder.fwoStartOdometer || ""}
                                        onChange={(e) => setWorkOrder(prev => ({ ...prev, fwoStartOdometer: e.target.value }))}
                                        editMode={editMode}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />

                                </div>
                                <div className="field" style={{ marginBottom: "15px", marginTop: "15px" }}>
                                    <CheckBox
                                        label="Use Odometer for Completion Meter"
                                        checked={workOrder.fwoSameOdometer === true}
                                        onChange={() => {
                                            const isChecked = workOrder.fwoSameOdometer === true;
                                            setWorkOrder(prev => ({
                                                ...prev,
                                                fwoSameOdometer: !isChecked,
                                                ...(isChecked ? {
                                                    fwoCompletionOdometer: workOrder.fwoStartOdometer
                                                } : {})
                                            }));
                                        }}
                                        required={true}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                    />
                                </div>
                                <div className="two fields">
                                    <Input
                                        type="text"
                                        label="Completion Odometer"
                                        name="fwoCompletionOdometer"
                                        value={workOrder.fwoSameOdometer === true ? workOrder.fwoStartOdometer : workOrder.fwoCompletionOdometer || ""}
                                        onChange={(e) => setWorkOrder(prev => ({ ...prev, fwoCompletionOdometer: e.target.value }))}
                                        editMode={editMode}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        disabled={workOrder.fwoSameOdometer === true}
                                        error={
                                            workOrder.fwoSameOdometer !== true &&
                                                workOrder.fwoCompletionOdometer &&
                                                String(workOrder.fwoCompletionOdometer).trim() !== "" &&
                                                workOrder.fwoStartOdometer &&
                                                Number(workOrder.fwoCompletionOdometer) < Number(workOrder.fwoStartOdometer)
                                                ? "Completion Odometer must be greater than or equal to Start Odometer"
                                                : currentErrors?.fwoCompletionOdometer
                                        }
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoCompletionOdometer: _, ...rest } = prevState || {};
                                                return rest;
                                            })
                                        }
                                    />
                                </div>
                                <div className="two fields">
                                    <DateTimePickerInput
                                        required={true}
                                        label="Expected Completion Date"
                                        name="fwoExpectedCompletionDate"
                                        placeholder={"Expected Completion Date"}
                                        value={workOrder.fwoExpectedCompletionDate || ""}
                                        onAccept={(val) => {
                                            setWorkOrder((prev) => ({
                                                ...prev,
                                                fwoExpectedCompletionDate: val,

                                            }));
                                        }}
                                        editMode={editMode}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoExpectedCompletionDate: _, ...rest } = prevState;
                                                return rest;
                                            })
                                        }
                                        minDateTime={workOrder.fwoScheduledStatrtTime ?? new Date()}
                                        error={currentErrors.fwoExpectedCompletionDate}
                                    />
                                    <DateTimePickerInput
                                        required={workOrder.fwoStatus === 3 || workOrder.fwoStatus === 4}
                                        label="Actual Completion Date"
                                        name="fwoActualCompletionDate"
                                        value={workOrder.fwoActualCompletionDate || ""}
                                        onAccept={(val) => {
                                            setWorkOrder((prev) => ({
                                                ...prev,
                                                fwoActualCompletionDate: val,
                                                fwoStatus: 3
                                            }));
                                        }}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        disabled={issueList.length > 0 && !issueList.every((issue) => !!issue.fwiEndTime)}
                                        editMode={editMode}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        validators={(() => {
                                            const endTimes = issueList.map(i => i.fwiEndTime).filter(Boolean);
                                            if (endTimes.length === 0) return [];
                                            const maxEnd = endTimes.reduce((max, t) => (new Date(t) > new Date(max) ? t : max));
                                            return [{
                                                func: (date) => {
                                                    const actualMin = Math.floor(date.valueOf() / 60000);
                                                    const scheduledMin = Math.floor(new Date(maxEnd).valueOf() / 60000);
                                                    return actualMin >= scheduledMin;
                                                },
                                                message: "Actual Completion Date must be on or after the latest issue End Date & Time",
                                            }];
                                        })()}
                                        minDateTime={workOrder.fwoActualStatrtDate}
                                        maxDateTime={new Date()}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoActualCompletionDate: _, ...rest } = prevState;
                                                return rest;
                                            })
                                        }
                                        error={currentErrors.fwoActualCompletionDate}
                                    />
                                </div>
                                <div className="two fields">
                                    <Dropdown
                                        label="Status"
                                        required={true}
                                        placeholder="Status"
                                        options={statusOpt}
                                        value={workOrder.fwoStatus}
                                        editMode={editMode}
                                        onChange={(e, data) => {
                                            manualStatusChangeRef.current = true;
                                            setWorkOrder((prevState) => ({
                                                ...prevState,
                                                fwoStatus: data.value,
                                                fwoActualCompletionDate: data.value === 1 || data.value === 2 || data.value === 5 || data.value === 6 ? null : workOrder.fwoActualCompletionDate,
                                            }));
                                            if (data.value !== 3) {
                                                setCurrentErrors((prevState) => {
                                                    const { fwoActualCompletionDate: _, ...rest } = prevState || {};
                                                    return rest;
                                                });
                                            }
                                        }}
                                        disabled={!editMode}
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        error={currentErrors.fwoStatus}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoStatus: _, ...rest } = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Dropdown
                                        required={true}
                                        label="Active"
                                        error={currentErrors.fwoActive}
                                        module={MODULES.Fleet}
                                        form={FORM}
                                        field="sha_active"
                                        needDeletePermission={true}
                                        editMode={editMode}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const { fwoActive: _, ...rest } = prevState;
                                                return rest;
                                            })
                                        }
                                        placeholder="Active"
                                        readOnly={(currentValues?.workOrder?.fwoStatus === 3 && !closePermission) || currentValues?.workOrder?.fwoStatus === 4}
                                        options={activeOptions}
                                        value={workOrder.fwoActive}
                                        style={{ height: "20px" }}
                                        onChange={(e, data) => {
                                            setWorkOrder((prevState) => ({
                                                ...prevState,
                                                fwoActive: data.value,
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {editMode && (
                            <InfoList
                                title="User Information"
                                content={[
                                    {
                                        title: "Created By",
                                        value: workOrder.createdBy ? workOrder.createdBy : "N/A",
                                    },
                                    {
                                        title: "Created Date",
                                        value: workOrder.createdDate
                                            ? formatFromJsonDate(workOrder.createdDate)
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified By",
                                        value: workOrder.lastModifiedBy
                                            ? workOrder.lastModifiedBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified Date",
                                        value: workOrder.lastModifiedDate
                                            ? formatFromJsonDate(workOrder.lastModifiedDate)
                                            : "N/A",
                                    },
                                ]}
                                Icon={User}
                            />
                        )}
                    </form>
                </div>
            )}

            <style>{`
                .ui.page.modals.dimmer {
                    z-index: 1300 !important;
                }
            `}</style>

            {/* Issue Selection Modal */}
            <Modal minWidth={"60vw"} ref={modalRef} closeButton={true}>
                <div style={{ padding: "10px" }}>
                    <Grid
                        heading="Available Issues"
                        config={[
                            {
                                headerName: "Issue No",
                                field: "fliCode",
                            },
                            {
                                headerName: "Topic",
                                field: "fliTopic",
                                cellRenderer: ResizableScrollingTextRenderer,
                            },
                            {
                                headerName: "Priority",
                                field: "priority",
                                cellRenderer: IssuePriorityCellStyle,
                            },
                            {
                                headerName: "Action",
                                field: "action",
                                filter: true,
                                cellRenderer: (props) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            className="ui button"
                                            type="button"
                                            template="addOrSave"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setIssueList(prev => {
                                                    if (prev.some(ai => ai.fliId === props.data.fliId)) return prev;
                                                    return [...prev, props.data];
                                                });
                                            }}
                                        />
                                    </div>
                                )
                            }
                        ]}
                        content={availableIssues.filter(ai => {
                            const existingIds = issueList.map(item =>
                                item?.issue?.fliId ?? item?.fwiIssue ?? item?.fliId
                            );
                            return !existingIds.includes(ai.fliId);
                        })}
                    />
                </div>
            </Modal>
            <Modal
                minWidth={"70vw"}
                minHeight={"80vh"}
                ref={docModalRef}
                closeButton={true}
                clickOutSide={false}
                onCloseCleanUp={() => {
                    setActiveDocVendorKey(null);
                    setActiveDocFwivId(null);
                }}
            >
                <div style={{ padding: "10px" }}>
                    <h4 className="ui dividing header">
                        Upload Documents
                        {!editMode && (
                            <span style={{ fontSize: "0.75rem", fontWeight: "normal", marginLeft: "12px", color: "#888" }}>
                                Documents will be saved when you submit the Work Order
                            </span>
                        )}
                    </h4>

                    {activeDocVendorKey !== null && (
                        <DocumentUpload
                            key={activeDocVendorKey}
                            ref={docUploadRef}
                            opeType={31}
                            reference={activeDocFwivId ?? activeDocVendorKey}
                            editMode={editMode && !!activeDocFwivId}
                            currentValues={
                                editMode && activeDocFwivId
                                    ? (existingDocs[activeDocVendorKey] || null)
                                    : (pendingDocsByVendorKey[activeDocVendorKey]?.length > 0
                                        ? pendingDocsByVendorKey[activeDocVendorKey]
                                        : null)
                            }
                            isLoading={false}
                            isOnTheModal={true}
                            module={MODULES.Fleet}
                            dropdown={{
                                documentTypeOptions: docTypeOptions,
                                statusOptions: docStatusOptions,
                                activeOptions: activeOptions,
                                fileNameOptions: fileNameOptions,
                            }}
                        />
                    )}

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", gap: "8px" }}>
                        <Button
                            type="button"
                            template="create"
                            label={editMode && activeDocFwivId ? "Save Documents" : "Queue Documents"}
                            isLoading={isDocSaveLoading}
                            disabled={editMode === true ? workOrder.fwoStatus === 4 || workOrder.fwoStatus === 3 : false}
                            onClick={async (e) => {
                                e.preventDefault();
                                if (!docUploadRef.current) return;
                                setIsDocSaveLoading(true);
                                try {
                                    const docData = docUploadRef.current.getData();

                                    if (editMode && activeDocFwivId) {
                                        // ── EDIT MODE: upload immediately using real fwivId ──────────
                                        for (const doc of (docData.created || [])) {
                                            const { file, ...rest } = doc;
                                            const fd = new FormData();
                                            fd.append("multipartFile", file);
                                            fd.append("documentRequest", JSON.stringify({ ...rest, docReference: activeDocFwivId }));
                                            fd.append("isImage", rest.docCategory === 1);
                                            await addAndUpload(fd);
                                        }
                                        for (const doc of (docData.modified || [])) {
                                            const { file, ...rest } = doc;
                                            const fd = new FormData();
                                            fd.append("multipartFile", file);
                                            fd.append("documentRequest", JSON.stringify(rest));
                                            fd.append("isImage", rest.docCategory === 1);
                                            await updateAndUpload(fd);
                                        }
                                        if (docData.deleted?.length > 0) {
                                            await deleteDocumentList({ docIdList: docData.deleted });
                                        }
                                        toast.success("Documents saved successfully", { containerId: "Modal" });
                                        docModalRef.current?.close();
                                        setActiveDocVendorKey(null);
                                        setActiveDocFwivId(null);

                                    } else {
                                        const files = Array.isArray(docData) ? docData : [];
                                        setPendingDocsByVendorKey(prev => ({
                                            ...prev,
                                            [activeDocVendorKey]: files,
                                        }));
                                        const count = files.length;
                                        toast.info(
                                            count > 0
                                                ? `${count} document(s) queued — they will upload when you save the Work Order.`
                                                : "No documents queued.",
                                            { containerId: "Modal" }
                                        );
                                        docModalRef.current?.close();
                                        setActiveDocVendorKey(null);
                                        setActiveDocFwivId(null);
                                    }
                                } catch (err) {
                                    console.error(err);
                                    toast.error("Failed to save documents", { containerId: "Modal" });
                                } finally {
                                    setIsDocSaveLoading(false);
                                }
                            }}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
});

export default WorkOrderForm;
